import { defineMessages } from 'react-intl';

export default defineMessages({
  addNewAddDocumentAppeal: {
    id: 'legal_proceeding_page.appeal_add.appeal_add_pronouncing.add_new_add',
  },
  successAppealAdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  cancelMessage: {
    id: 'saham_dialog.cancel',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successDialogTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.title',
  },
  successToastTitle: {
    id: 'appeal_add_document.success',
  },
  supportDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.support_document',
  },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  editButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.updateButton',
  },
  creatorTitle: {
    id: 'legal_proceeding_page.update_firm_reference_lawyer_name',
  },
  lawyerFirmReferenceEditMessage: {
    id: 'legal_proceeding_page.check_update_firm_reference_info',
  },
  courtManagerJudgementUpdate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.update',
  },
  userNotValidWarning: {
    id: 'restricted_user_warning.title',
  },
  duplicateJaddWarning: {
    id: 'duplicate_add_warning.title',
  },
  intervenantName: {
    id: 'invoice.dialog_info.intervenant.name',
  },
  validationMessage: { id: 'appeal_add_update.success' },
});
